import { render } from "./MenuBaoView.vue?vue&type=template&id=638e8e44&scoped=true"
import script from "./MenuBaoView.vue?vue&type=script&lang=js"
export * from "./MenuBaoView.vue?vue&type=script&lang=js"

import "./MenuBaoView.vue?vue&type=style&index=0&id=638e8e44&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638e8e44"]])

export default __exports__